interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  size?: 'sm' | 'md';
}

const sizeMap = {
  sm: { track: 'h-5 w-9', knob: 'h-4 w-4 top-0.5 right-0.5', shift: 'translate-x-[-16px]' },
  md: { track: 'h-6 w-11', knob: 'h-5 w-5 top-0.5 right-0.5', shift: 'translate-x-[-20px]' },
};

export default function Switch({
  checked,
  onChange,
  disabled = false,
  label,
  size = 'md',
}: SwitchProps) {
  const style = sizeMap[size];

  const button = (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={[
        'relative inline-flex shrink-0 items-center rounded-full transition-colors duration-200',
        style.track,
        checked ? 'bg-success-500' : 'bg-background-400',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
      ].join(' ')}
    >
      <span
        className={[
          'absolute rounded-full bg-white shadow-sm transition-transform duration-200',
          style.knob,
          checked ? style.shift : '',
        ].join(' ')}
      ></span>
    </button>
  );

  if (!label) return button;

  return (
    <label className="flex items-center gap-2">
      {button}
      <span className="text-[13px] text-foreground-700">{label}</span>
    </label>
  );
}